var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vx-card",
    {
      attrs: {
        title:
          _vm.id === null
            ? "Cadastrar Estabelecimento"
            : "Editar Estabelecimento",
      },
    },
    [
      _c(
        "vs-tabs",
        {
          attrs: { color: _vm.colorx },
          model: {
            value: _vm.tabIndex,
            callback: function ($$v) {
              _vm.tabIndex = $$v
            },
            expression: "tabIndex",
          },
        },
        [
          _c(
            "vs-tab",
            { attrs: { label: "Dados Básicos" } },
            [
              _c("LegalEntityForm", {
                attrs: {
                  services: _vm.services,
                  legalEntityId: _vm.id,
                  legalEntity: _vm.legalEntity,
                },
                on: { "update-data": _vm.handleUpdateDataLegalEntity },
              }),
            ],
            1
          ),
          _c(
            "vs-tab",
            { attrs: { label: "Responsável", disabled: _vm.isTabEnabled } },
            [
              _vm.legalEntity.people_id
                ? _c("Responsable", {
                    attrs: {
                      services: _vm.services,
                      legalEntityId: _vm.legalEntity.id,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _c(
            "vs-tab",
            { attrs: { label: "Endereço", disabled: _vm.isTabEnabled } },
            [
              _vm.legalEntity.people_id
                ? _c("Address", {
                    attrs: {
                      services: _vm.services,
                      people_id: _vm.legalEntity.people_id,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _c(
            "vs-tab",
            { attrs: { label: "Telefone", disabled: _vm.isTabEnabled } },
            [
              _vm.legalEntity.people_id
                ? _c("Phone", {
                    attrs: {
                      services: _vm.services,
                      people_id: _vm.legalEntity.people_id,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _c(
            "vs-tab",
            { attrs: { label: "Email", disabled: _vm.isTabEnabled } },
            [
              _vm.legalEntity.people_id
                ? _c("Email", {
                    attrs: {
                      services: _vm.services,
                      people_id: _vm.legalEntity.people_id,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _c(
            "vs-tab",
            { attrs: { label: "Dados Bancários", disabled: _vm.isTabEnabled } },
            [
              _vm.legalEntity.people_id
                ? _c("Bank", {
                    attrs: {
                      services: _vm.services,
                      serviceDelegate: _vm.services.legalEntityService,
                      entityId: _vm.id,
                      people_id: _vm.legalEntity.people_id,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _c(
            "vs-tab",
            { attrs: { label: "Professores", disabled: _vm.isTabEnabled } },
            [
              _vm.legalEntity.people_id
                ? _c("Teacher", {
                    attrs: {
                      services: _vm.services,
                      people_id: _vm.legalEntity.people_id,
                      legalEntityId: _vm.legalEntity.id,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _c(
            "vs-tab",
            { attrs: { label: "Modalidades", disabled: _vm.isTabEnabled } },
            [
              _vm.legalEntity.people_id
                ? _c("Modality", {
                    attrs: {
                      services: _vm.services,
                      serviceDelegate: _vm.services.legalEntityService,
                      people_id: _vm.legalEntity.people_id,
                      entityId: _vm.id,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _c(
            "vs-tab",
            {
              attrs: { label: "Repasse (Stripe)", disabled: _vm.isTabEnabled },
            },
            [
              _vm.legalEntity.id
                ? _c("StripeConnect", {
                    attrs: { legalEntityId: _vm.legalEntity.id },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm.canSeeBillingPlan
            ? _c(
                "vs-tab",
                {
                  attrs: {
                    label: "Plano de Cobrança",
                    disabled: _vm.isTabEnabled,
                  },
                },
                [
                  _vm.legalEntity.id
                    ? _c("BillingPlan", {
                        attrs: { legalEntityId: _vm.legalEntity.id },
                      })
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _c(
            "vs-tab",
            { attrs: { label: "Imagens", disabled: _vm.isTabEnabled } },
            [
              _vm.legalEntity.people_id
                ? _c("Images", {
                    attrs: {
                      serviceDelegate: _vm.services.legalEntityService,
                      people_id: _vm.legalEntity.people_id,
                      entityId: _vm.legalEntity.id,
                      imagesList: _vm.legalEntity.images,
                      target: "legal_entities",
                      hint: "Tamanho recomendado: 1200×675px (paisagem, 16:9), mesma proporção da capa.",
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }